import { Collapse, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { CheckBoxGroup } from "./CheckBoxGroup";
import { useState } from "react";
import accdown from "../assets/images/accdown.svg";
import accup from "../assets/images/accup.svg";

export function CustomAccordion({ filterOption}) {
    const [open,setAccordion] = useState(false);
    return <Box sx={{ display: "flex", flexDirection: "column", padding: "14px 18px",borderBottom:"1px solid #D4D4D4",gap:"5px"}}>
        <Box onClick={() => {
            setAccordion((prev)=>!prev);
        }} sx={{
            "&:hover": {
                cursor: "pointer"
            },display: 'flex', flexDirection: "row", justifyContent: "space-between",alignItems:"center"
        }}>
            <Typography sx={{ fontFamily: "Barlow", color:open? process.env.REACT_APP_ENTERPRISE_COLOUR : "black", fontSize: "14px", fontWeight:open?"bold":"semibold" }}>{filterOption.title}</Typography>
            <img src={open?accup : accdown} />
        </Box>
        <Collapse in={open} timeout="auto" unmountOnExit={false}><Box sx={{ display:"flex",overflowY: "auto",flexDirection:"column",maxHeight:"300px",width:"100%","&::-webkit-scrollbar":{
            width:"2px"
        }}}>
              <CheckBoxGroup options={filterOption.options} />
            </Box></Collapse>
    </Box>
}